'use client';
import React, { useState } from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import AppLogo from '@/components/ui/AppLogo';
import Icon from '@/components/ui/AppIcon';
import LanguageSwitcher from '@/components/LanguageSwitcher';
import { useLanguage } from '@/context/LanguageContext';

export default function PublicTopbar() {
  const pathname = usePathname();
  const [mobileOpen, setMobileOpen] = useState(false);
  const { t } = useLanguage();

  const navLinks = [
    { label: t('nav.services'), href: '/services-booking', key: 'nav-services' },
    { label: t('nav.adminPanel'), href: '/admin-panel', key: 'nav-admin' },
  ];

  return (
    <header className="sticky top-0 z-50 bg-white border-b border-border shadow-card">
      <div className="max-w-screen-2xl mx-auto px-6 lg:px-8 xl:px-10 2xl:px-16 h-16 flex items-center justify-between">
        {/* Logo */}
        <Link href="/services-booking" className="flex items-center gap-2 group">
          <AppLogo size={44} />
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-1">
          {navLinks?.map((link) => (
            <Link
              key={link?.key}
              href={link?.href}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-150 ${
                pathname === link?.href
                  ? 'bg-primary/10 text-primary' :'text-muted-foreground hover:text-foreground hover:bg-muted'
              }`}
            >
              {link?.label}
            </Link>
          ))}
        </nav>

        {/* Right actions */}
        <div className="flex items-center gap-2">
          <LanguageSwitcher />
          <Link
            href="/sign-up-login"
            className="hidden md:inline-flex items-center gap-2 px-4 py-2 text-sm font-medium text-primary border border-primary rounded-lg hover:bg-primary/5 transition-all duration-150 active:scale-95"
          >
            {t('nav.signIn')}
          </Link>
          <Link
            href="/sign-up-login"
            className="hidden md:inline-flex items-center gap-2 px-4 py-2 text-sm font-semibold text-white bg-primary rounded-lg hover:bg-primary-light transition-all duration-150 active:scale-95"
          >
            {t('nav.getStarted')}
          </Link>
          {/* Mobile hamburger */}
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden p-2 rounded-lg hover:bg-muted transition-colors"
            aria-label="Toggle menu"
          >
            <Icon name={mobileOpen ? 'XMarkIcon' : 'Bars3Icon'} size={20} />
          </button>
        </div>
      </div>
      {/* Mobile drawer */}
      {mobileOpen && (
        <div className="md:hidden bg-white border-t border-border px-6 py-4 flex flex-col gap-2">
          {navLinks?.map((link) => (
            <Link
              key={`mobile-${link?.key}`}
              href={link?.href}
              onClick={() => setMobileOpen(false)}
              className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                pathname === link?.href
                  ? 'bg-primary/10 text-primary' :'text-muted-foreground hover:text-foreground hover:bg-muted'
              }`}
            >
              {link?.label}
            </Link>
          ))}
          <div className="flex gap-2 pt-2 border-t border-border mt-2">
            <Link
              href="/sign-up-login"
              onClick={() => setMobileOpen(false)}
              className="flex-1 text-center px-4 py-2.5 text-sm font-medium text-primary border border-primary rounded-lg hover:bg-primary/5 transition-colors"
            >
              {t('nav.signIn')}
            </Link>
            <Link
              href="/sign-up-login"
              onClick={() => setMobileOpen(false)}
              className="flex-1 text-center px-4 py-2.5 text-sm font-semibold text-white bg-primary rounded-lg hover:bg-primary-light transition-colors"
            >
              {t('nav.getStarted')}
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}